import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {ContractDuration} from '@dcp/configurator';

@Injectable({
  providedIn: 'root'
})
export class ContractDurationService {

  private contractDuration = new BehaviorSubject<ContractDuration | null>(null);
  public readonly contractDuration$: Observable<ContractDuration> = this.contractDuration.asObservable();


  setContractDuration(contractDuration: any) {
    this.contractDuration.next(contractDuration);
  }

}
